import { render, staticRenderFns } from "./IconAccess.vue?vue&type=template&id=1d9b465d&scoped=true&"
import script from "./IconAccess.vue?vue&type=script&lang=js&"
export * from "./IconAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9b465d",
  null
  
)

export default component.exports